import { Redirect } from 'expo-router';
import Head from 'expo-router/head';
import { useIntl } from 'react-intl';

import { ScreenContent } from '@fhs/screen-content';
import { tokens, useMqSelect } from '@fhs/ui';
import Footer from 'components/footer';
import { PaymentMethodFlatListWithButton } from 'components/payment-method-flat-list-with-button';
import { useAuthContext } from 'state/auth';
import { routes } from 'utils/routing';

const PaymentMethods = () => {
  const { isAuthenticated } = useAuthContext();
  const { formatMessage } = useIntl();
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);

  if (!isAuthenticated) {
    return <Redirect href={routes.base} />;
  }

  return (
    <>
      <Head>
        <title>{`${formatMessage({ id: 'paymentMethods' })} - Firehouse Subs`}</title>
      </Head>
      <ScreenContent
        after={isDesktop ? <Footer /> : <></>}
        style={{ backgroundColor: tokens.colors.$white }}
      >
        <PaymentMethodFlatListWithButton />
      </ScreenContent>
    </>
  );
};

export default PaymentMethods;
